import React, { useCallback } from 'react';
import { ALL_SPORTS_ID } from '~/web-frontend-core/store/results/live/Menu';
export const ResultsSportFilter = (props) => <div className='results-sport clearfix'>
      <ul className='sport-list clearfix'>
         {props.data.topSports
        .map((sport) => ({
        isSelected: props.isSelected(sport.id),
        name: props.toLocale(sport.name),
        hasMatches: sport.hasMatches,
        select: props.select,
        id: sport.id,
    }))
        .map((props) => <MenuItem {...props} key={`filter_item_${props.id}`}/>)}
      </ul>
   </div>;
const MenuItem = React.memo((props) => <li>
      <button className={`${props.isSelected && props.hasMatches ? 'on' : ''}${!props.hasMatches ? 'disabled' : ''}`} onClick={useCallback(() => { props.select(props.id, !props.isSelected); }, [props.id, props.isSelected])} disabled={!props.hasMatches}>
         {props.id !== ALL_SPORTS_ID && <span className={`f-s-ico-${props.id}`}/>}
         {props.name}
      </button>
   </li>);



// WEBPACK FOOTER //
// ./src/web-frontend-components/results/live/Menu.jsx